var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Modal } from "../../../../../../Components/UI";
import { Translate } from "../../../../../../../I18N";
import { AddExtractorSteps } from "./steps";
import { useCreateExtractorContext } from "./CreateExtractorContext";
import { Steppers } from "./Steppers";

const Dialog = () => {
  const { step, setShowModal, targetTemplateOptions } = useCreateExtractorContext();
  const CurrentStepBody = AddExtractorSteps[step].Body;
  const CurrentStepFooter = AddExtractorSteps[step].Footer;

  return (/*#__PURE__*/
    _jsx(Modal, { size: "xxl" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-lg font-semibold text-gray-900" }, void 0, AddExtractorSteps[step].title()), /*#__PURE__*/
    _jsx("p", { className: "mt-1 text-sm font-light text-gray-500" }, void 0,
    AddExtractorSteps[step].description()
    )
    ), /*#__PURE__*/

    _jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
    ), /*#__PURE__*/
    _jsx(Modal.Body, { className: "pt-0" }, void 0, /*#__PURE__*/
    _jsx(CurrentStepBody, {}), /*#__PURE__*/
    _jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
    _jsx(Steppers, {
      step: step,
      steps: Object.keys(AddExtractorSteps).length,
      isDisabled: targetTemplateOptions.length === 0 }
    ),
    step === 1 && /*#__PURE__*/
    _jsx("span", { className: "mt-5 text-xs font-light text-gray-500 max-w-[500px]" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Only templates with at least one rich text property and one numeric property are available for selection."


    )
    ),

    step === 2 && /*#__PURE__*/
    _jsx("span", { className: "mt-5 text-xs font-light text-gray-500 max-w-[500px]" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Only templates that are not used as source in any other extractor and are not selected as target in this extractor are available for selection."


    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(CurrentStepFooter, {})
    )
    )
    )
    ));

};

export { Dialog };